/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import cx from "classnames";
import { Form } from "../Form";
import Button from "components/Button";

import styles from "./FormButton.module.scss";

const { Field } = Form;

interface IFormButtonProps {
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean;
  nonEmptyFields?: { requiredFields: string[]; autoCompleted: boolean };
  loading?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const FormButton = ({
  type = "submit",
  disabled,
  nonEmptyFields,
  loading,
  children,
  className,
}: IFormButtonProps) => {
  const checkIfEmpty = (fields: { [key: string]: string }) =>
    nonEmptyFields?.requiredFields.some(
      (field) =>
        fields[field] === "" ||
        (!fields[field] && !nonEmptyFields.autoCompleted)
    );

  return (
    <Field shouldUpdate={true}>
      {(control, meta, form) => {
        const hasErrors = !!form
          .getFieldsError()
          .filter(({ errors }) => errors.length).length;

        return (
          <Button
            className={cx(styles.button, className)}
            type={type}
            size="medium"
            variant="primary"
            state={
              loading
                ? "loading"
                : hasErrors ||
                  disabled ||
                  (nonEmptyFields && checkIfEmpty(form.getFieldsValue()))
                ? "disabled"
                : "default"
            }
          >
            {children}
          </Button>
        );
      }}
    </Field>
  );
};

export default FormButton;
